import React, { memo } from 'react';

import AbsoluteError from 'components/AbsoluteError';
import { getLiteral } from 'utils/getLiteral';

export const RatesAddItemsError = memo(() => <AbsoluteError />);

RatesAddItemsError.displayName = 'RatesAddItemsError';

export const RatesAddItemsEmpty = memo(() => (
    <AbsoluteError subtitle={getLiteral('warning_search_empty_result')} />
));

RatesAddItemsEmpty.displayName = 'RatesAddItemsEmpty';
